module.exports = __webpack_public_path__ + "img/78.843dddf.png";